import React from "react";
import { MediaPlayButton } from "media-chrome/react";
import { PauseIcon, PlayIcon } from "assets";
import "./styles.scss";

interface Props {
  isPrimary?: boolean;
}

const PlayButton = ({ isPrimary }: Props) => {
  const size = isPrimary ? 40 : 20;

  if (isPrimary) {
    return (
      <MediaPlayButton className="play-button primary bg-transparent" noTooltip>
        <span slot="play">
          <PlayIcon
            width={size}
            height={size}
            className="drop-shadow-profile"
          />
        </span>
        <span slot="pause">
          <PauseIcon
            width={size}
            height={size}
            className="drop-shadow-profile"
          />
        </span>
      </MediaPlayButton>
    );
  }

  return (
    <MediaPlayButton className="play-button bg-transparent p-0">
      <span slot="play">
        <PlayIcon width={size} height={size} />
      </span>
      <span slot="pause">
        <PauseIcon width={size} height={size} />
      </span>
    </MediaPlayButton>
  );
};

export default PlayButton;
